import { render, staticRenderFns } from "./majorIncomeAnalysis.vue?vue&type=template&id=3fafa387&scoped=true&"
import script from "./majorIncomeAnalysis.vue?vue&type=script&lang=js&"
export * from "./majorIncomeAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./majorIncomeAnalysis.vue?vue&type=style&index=0&id=3fafa387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fafa387",
  null
  
)

export default component.exports